import { useEffect, useState } from 'react';

export function useScrollOffset(threshold = 16): boolean {
  // Lazy-init from current scrollY so a page loaded mid-scroll (anchor link, refresh)
  // doesn't render one frame as `false` before the effect's onScroll() flips it.
  const [isOffset, setIsOffset] = useState(
    () => typeof window !== 'undefined' && window.scrollY > threshold,
  );

  useEffect(() => {
    const onScroll = () => {
      setIsOffset(window.scrollY > threshold);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return isOffset;
}
